import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { DialogComponent } from '@app/shared/components/dialog/dialog.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'topo-template-group-delete-dialog',
  imports: [DialogComponent, TranslatePipe],
  templateUrl: './template-group-delete-dialog.component.html',
  styleUrl: './template-group-delete-dialog.component.scss'
})
export class TemplateGroupDeleteDialogComponent {
  protected dialogRef = inject<DialogRef>(DialogRef);
  data = inject(DIALOG_DATA);
}
